import camelCase from "./utils/camelCase";
import facetwpPagination from "./utils/pagination";
import AOS from "aos";
import lozad from "lozad";

// Lazy loads elements with default selector '.lozad'
// Affects most page-builder components and templated images
const observer = lozad();
observer.observe();

// Lazy loads elements in .post-content
const images = document.querySelector('.post-content img');
const observer2 = lozad(images); // passing a `NodeList` (e.g. `document.querySelectorAll()`) is also valid
observer2.observe();

document.addEventListener("DOMContentLoaded", () => {

    // AOS animations
    // init AOS
    let aosOffset = -150,
        aosDuration = 400;

    AOS.init({
        duration: aosDuration,
        easing: "ease-out-cubic",
        startEvent: "load",
        offset: 0,
        once: true
    });

    // Sets asset ID values in cookie for cross-page tracking

    // Set assetId value, if it exists
    let idDiv = document.getElementById('spotAssetId');
    let assetId = undefined;
    if (idDiv) {
        assetId = idDiv.attributes.name.value;
    }

    let name = "spotAssetIdCookie";
    // If an assetId exists, set/rewrite the session cookie
    if (assetId) {
        document.cookie = name + "=" + assetId + ";" + "path=/;";
    }

    // Allow demo form elements to fully load
    setTimeout(function() {
        // target assetId hidden field
        const assetIdField = document.querySelectorAll('[name="mktoSpotAssetID"]');
        if (assetIdField.length > 0 && getCookieValue(name) !== undefined) {
            assetIdField[0].setAttribute('value', getCookieValue(name));
        }
    }, 2000);

    // Utility function to get cookie value by name
    const getCookieValue = (cname) => (
        document.cookie.match('(^|;)\\s*' + cname + '\\s*=\\s*([^;]+)')?.pop() || ''
    );

});

// Run Facetwp pagination function when facetwp-loaded event fires
document.addEventListener("facetwp-loaded", facetwpPagination);

// Check all component partials for inclusion
document.addEventListener("DOMContentLoaded", () => {

    const checkForElement = (element) => {
        if (typeof element != "undefined") {
            return element;
        }
        return false;
    };

    const components = document.querySelectorAll(".component");
    if (!components.length) return;

    let componentsArray = [];
    components.forEach(async (module) => {
        let classList = checkForElement(module.classList);
        let name = classList[1];
        if (name) {
            name = camelCase(name);
            if ($.inArray(name, componentsArray) == -1) {
                componentsArray.push(name);
            }
        } else {
            console.error("No component name found");
            return;
        }
    });

    if (componentsArray.length) {
        componentsArray.forEach(async (name) => {
            try {
                const { Component } = await import(/* webpackChunkName: 'component' */ `./components/${name}`);
                const component = new Component(name);
                component.init();
            } catch (error) {
                console.log(error);
                console.warn(
                    `You're missing the js file for the ${name} component. \n Create the missing file inside the components folder: /themes/instaclustr/assets/js/components/${name}.js`
                );
            }
        });
    }
});

